export default function mapper(settings) {
    var _a, _b;
    const apiPayload = {};
    if (settings.aiInspectionManagerEnabled !== undefined) {
        apiPayload.ai_inspection_manager_enabled = settings.aiInspectionManagerEnabled;
    }
    if (settings.aiInspectionManagerGrammarAndStyleEnabled !== undefined) {
        apiPayload.ai_inspection_manager_grammar_and_style_enabled = settings.aiInspectionManagerGrammarAndStyleEnabled;
    }
    if (settings.aiInspectionManagerUnansweredQuestionsEnabled !== undefined) {
        apiPayload.ai_inspection_manager_unanswered_questions_enabled =
            settings.aiInspectionManagerUnansweredQuestionsEnabled;
    }
    if (settings.aiInspectionManagerNeedsCorrectionEnabled !== undefined) {
        apiPayload.ai_inspection_manager_needs_correction_enabled = settings.aiInspectionManagerNeedsCorrectionEnabled;
    }
    if (settings.aiInspectionManagerMissingInformationEnabled !== undefined) {
        apiPayload.ai_inspection_manager_missing_information_enabled =
            settings.aiInspectionManagerMissingInformationEnabled;
    }
    if (settings.aiInspectionManagerOfficeOnlyEnabled !== undefined) {
        apiPayload.ai_inspection_manager_office_only_enabled = settings.aiInspectionManagerOfficeOnlyEnabled;
    }
    if (settings.aiInspectionManagerRequireIssueResolutionEnabled !== undefined) {
        apiPayload.ai_inspection_manager_require_issue_resolution_enabled =
            settings.aiInspectionManagerRequireIssueResolutionEnabled;
    }
    if (settings.inspectionManagerAgentEnabled !== undefined) {
        apiPayload.inspection_manager_agent_enabled = settings.inspectionManagerAgentEnabled;
    }
    if (settings.inspectionAssistantTeaserEnabled !== undefined) {
        apiPayload.inspection_assistant_teaser_enabled = settings.inspectionAssistantTeaserEnabled;
    }
    if (settings.aiInspectionManagerTechniciansBlacklist !== undefined) {
        apiPayload.ai_inspection_manager_technicians_blacklist = settings.aiInspectionManagerTechniciansBlacklist;
    }
    if (settings.iaMode !== undefined) {
        apiPayload.ia_mode = settings.iaMode;
    }
    if (settings.aiInspectionManagerGrammarAndStyleAdvancedSettings !== undefined) {
        if (settings.aiInspectionManagerGrammarAndStyleAdvancedSettings === null) {
            apiPayload.ai_inspection_manager_grammar_and_style_advanced_settings = null;
        }
        else {
            apiPayload.ai_inspection_manager_grammar_and_style_advanced_settings = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                include_in_high_impact_issues: settings.aiInspectionManagerGrammarAndStyleAdvancedSettings.includeInHighImpactIssues,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                excluded_terms: settings.aiInspectionManagerGrammarAndStyleAdvancedSettings.excludedTerms,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                included_terms: settings.aiInspectionManagerGrammarAndStyleAdvancedSettings.includedTerms
            };
        }
    }
    if (settings.aiInspectionManagerNeedsCorrectionAdvancedSettings !== undefined) {
        if (settings.aiInspectionManagerNeedsCorrectionAdvancedSettings === null) {
            apiPayload.ai_inspection_manager_needs_correction_advanced_settings = null;
        }
        else {
            apiPayload.ai_inspection_manager_needs_correction_advanced_settings = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                include_in_high_impact_issues: settings.aiInspectionManagerNeedsCorrectionAdvancedSettings.includeInHighImpactIssues,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                incorrect_reference_clause: settings.aiInspectionManagerNeedsCorrectionAdvancedSettings.incorrectReferenceClause
            };
        }
    }
    if (settings.aiInspectionManagerMissingInformationAdvancedSettings !== undefined) {
        if (settings.aiInspectionManagerMissingInformationAdvancedSettings === null) {
            apiPayload.ai_inspection_manager_missing_information_advanced_settings = null;
        }
        else {
            const missingInfo = settings.aiInspectionManagerMissingInformationAdvancedSettings;
            apiPayload.ai_inspection_manager_missing_information_advanced_settings = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                include_in_high_impact_issues: missingInfo.includeInHighImpactIssues,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                inspection_photo: missingInfo.inspectionPhoto,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                inspection_recommendations: missingInfo.inspectionRecommendations,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                signatures: missingInfo.signatures,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                time_entry_detection: missingInfo.timeEntryDetection,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                deficiency_photo: missingInfo.deficiencyPhoto,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                asset_exclusions: ((_a = missingInfo.assetExclusions) === null || _a === void 0 ? void 0 : _a.map((assetType) => assetType.value)) || [],
                // eslint-disable-next-line @typescript-eslint/naming-convention
                deficiency_notes: missingInfo.deficiencyNotes,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                flag_internal_notes: missingInfo.flagInternalNotes,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                missing_code_references: missingInfo.missingCodeReferences
            };
        }
    }
    if (settings.aiInspectionManagerUnansweredQuestionsAdvancedSettings !== undefined) {
        if (settings.aiInspectionManagerUnansweredQuestionsAdvancedSettings === null) {
            apiPayload.ai_inspection_manager_unanswered_questions_advanced_settings = null;
        }
        else {
            apiPayload.ai_inspection_manager_unanswered_questions_advanced_settings = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                include_in_high_impact_issues: settings.aiInspectionManagerUnansweredQuestionsAdvancedSettings.includeInHighImpactIssues,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                asset_exclusions: ((_b = settings.aiInspectionManagerUnansweredQuestionsAdvancedSettings.assetExclusions) === null || _b === void 0 ? void 0 : _b.map((assetType) => assetType.value)) || []
            };
        }
    }
    if (settings.aiInspectionManagerOfficeOnlyAdvancedSettings !== undefined) {
        if (settings.aiInspectionManagerOfficeOnlyAdvancedSettings === null) {
            apiPayload.ai_inspection_manager_office_only_advanced_settings = null;
        }
        else {
            apiPayload.ai_inspection_manager_office_only_advanced_settings = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                auto_resolve_unresolved_deficiencies: settings.aiInspectionManagerOfficeOnlyAdvancedSettings.autoResolveUnresolvedDeficiencies,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                auto_complete_on_tech_resolve: settings.aiInspectionManagerOfficeOnlyAdvancedSettings.autoCompleteOnTechResolve
            };
        }
    }
    return apiPayload;
}
